import React,{useEffect} from "react";

import "./Office.css";

import {office_admin_staffs} from '../../constants/office.js';

import { Backtotop,Underline } from "../../widgets";
import { Profile_display } from "../../components";
//import { ece_hod } from "../../constants/ece_dept.js";

// const principal="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Administration/Principal_office/eee-hod.webp",
const viceprincipal="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Administration/Principal_office/Vice-principal.webp"

const subramani="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Civil/Faculties/Teaching_fac/Civil+C.Subramanian-1.webp"


const Office = () => {
  useEffect(() => {
    document.title = 'ACCET-Office';
  }, []);
  return (
    <>
      <Backtotop />
      <div className="whole_content">
        <Underline heading="Principal Office"/>

        <div className="princ">
          <div className="princ_msg_head">Principal's Message:</div>
          <div className="princ_msg_content">
            <div className="princ_msg_content_img">
              <div className="princ_msg_content_img_pic">
                <img className="princ_pic" src={subramani} alt="Principal" />
              </div>
              <div className="princ_msg_content_desig">
                <div className="princ_name">Dr. C. Subramanian M.E, Ph.D</div>
                <div className="princ_desig">Principal</div>
              </div>
            </div>
            <div className="princ_msg_content_text">
      
It gives me immense pleasure to welcome all to Alagappa Chettiar Government College of Engineering and Technology (ACGCET), Karaikudi — an institution with a rich legacy of academic excellence, innovation, and service to society.
Our institution stands as a proud tribute to the vision and generosity of our esteemed founder, Dr. R. M. Alagappa Chettiar, a great educationist, philanthropist, and industrialist. Inspired by his ideals, ACGCET continues to uphold the values of knowledge, discipline, and social responsibility.
As our founder believed, “Education is the most valuable wealth that one can acquire and share for the betterment of society.” This guiding principle continues to inspire our mission and activities.

Since its inception, ACGCET has been committed to nurturing young minds by providing quality technical education combined with strong ethical values. Our institution strives to create competent engineers and responsible citizens who can contribute meaningfully to the nation and the global community.
In today’s rapidly evolving technological landscape, education must go beyond textbooks. At ACGCET, we emphasize a holistic approach that integrates academics, research, industry interaction, and co-curricular activities. Our dedicated faculty members continuously guide students to develop critical thinking, creativity, and problem-solving skills.
We also encourage students to actively participate in community service, entrepreneurship initiatives, and innovative projects. Through such engagements, we aim to instill leadership qualities, social responsibility, and a spirit of lifelong learning.
Our infrastructure, laboratories, and academic ecosystem are designed to support excellence in teaching and research. We take pride in our alumni who have excelled in various fields across the globe and continue to uphold the values of this esteemed institution.
I invite all students to make the most of the opportunities provided here, work with determination, and uphold the dignity and reputation of ACGCET.
Wishing you all success in your academic journey and future endeavors.

            </div>
          </div>
        </div>

         <div className="vice-princ">
          <div className="vice-princ_msg_head">Vice Principal's Message:</div>
          <div className="vice-princ_msg_content">
            <div className="vice-princ_msg_content_img">
              <div className="vice-princ_msg_content_img_pic">
                <img className="vice-princ_pic" src={viceprincipal} alt="Principal" />
              </div>
              <div className="vice-princ_msg_content_desig">
                <div className="vice-princ_name">Dr. K. Ramanathan M.E, Ph.D</div>
                <div className="vice-princ_desig">Vice Principal</div>
              </div>
            </div>
            <div className="vice-princ_msg_content_text">
           Greetings to all,
It is a matter of great pride and privilege to address the students, faculty, and well-wishers of Alagappa Chettiar Government College of Engineering and Technology (ACGCET), Karaikudi.


ACGCET has consistently upheld its legacy of delivering quality technical education and fostering an environment that promotes intellectual growth and professional excellence. Our focus extends beyond academics, aiming to develop well-rounded individuals equipped with knowledge, skills, integrity, and a sense of social commitment.
In the present era of rapid technological advancements, adaptability and continuous learning are essential. We encourage our students to explore new ideas, engage in innovative practices, and actively participate in academic, research, and extracurricular activities. Such involvement not only enhances their competencies but also prepares them to face real-world challenges with confidence.
The strength of our institution lies in the dedication of our faculty and the enthusiasm of our students. Together, we strive to create a vibrant academic ecosystem that nurtures creativity, critical thinking, and leadership qualities.
I urge every student to remain focused, disciplined, and proactive in their pursuits, making the most of the opportunities provided by the institution. Let us continue to work collectively towards excellence and uphold the proud tradition of ACGCET.
Best wishes for a successful and fulfilling future.

            </div>
          </div>
        </div>



        <div className="admin_staff">
          <Underline heading="Admistrative Staffs"/>
          <Profile_display list_info={office_admin_staffs}/>
        </div>

      </div>
    </>
  );
};

export default Office;
